import en from './en.json';

const translations: { [code: string]: any } = { en };
export default translations;
